import Link from 'next/link';
import Image from 'next/image';

export default function GastronomicalExperience() {

  return (
    <section className="relative mx-auto py-8 px-8 bigscreen-responsive xl:px-0 xl:mt-8">
      <div className="flex flex-col xl:flex-row justify-center xl:justify-between">
        <div className="flex flex-wrap justify-center text-center items-center xl:flex-nowrap xl:text-left">
          <Image src="./images/logos/escudo.svg" width={128} height={128} alt="Escudo Amura" />
          <div className="px-4 py-6">
            <p className="font-bold text-2xl">Iniciá tu aventura gastronómica</p>
            <p className="font-thin max-w-md py-4">La escuela de cocina que está revolucionando la forma de enseñar gastronomía</p>
          </div>
        </div>
        <div className="flex flex-wrap justify-center items-center gap-10 py-4 max-w-md text-sm md:max-w-5xl md:mx-auto xl:flex-nowrap xl:justify-start xl:gap-4 xl:max-w-lg xl:mx-auto">
          <Link href='/programas' className="text-white font-bold rounded-full py-4 px-8 bg-gradient-to-r from-[#FBA919] to-orange hover:shadow-lg xl:text-nowrap">
            Explorá los programas
          </Link>
          <Link href='https://wa.me/50662236864' target='_blank' className="font-bold rounded-full py-4 px-8 border-2 border-[#FBA919] hover:bg-[#FBA919]/15 hover:shadow-lg xl:text-nowrap">
            Contactanos
          </Link>
        </div>
      </div>
    </section>
  )
}


